export default __webpack_public_path__ + "static/media/tdbLogo.ab1327d6.png";